import { useLayoutEffect, useRef } from 'react'

export function useLatestRef<T>(value: T): React.RefObject<T> {
  const ref = useRef(value)

  useLayoutEffect(() => {
    ref.current = value
  }, [value])

  return ref
}
